import request from '../utils/request';
//观众邀请



//上传
export function upload(data) {

    // console.log("拦截的参数",data);
    let fd = new FormData();  //
    fd.append('file', data,"test.png");
  
    return request({
        url: '/frontCommon/upload',
        method: 'post',
        data: fd
    });
};
